import { render, staticRenderFns } from "./demo1.vue?vue&type=template&id=24197887&scoped=true"
import script from "./demo1.vue?vue&type=script&lang=js"
export * from "./demo1.vue?vue&type=script&lang=js"
import style0 from "./demo1.vue?vue&type=style&index=0&id=24197887&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24197887",
  null
  
)

export default component.exports